import { render, staticRenderFns } from "./ApiGolfRateShow.vue?vue&type=template&id=e69b6ee2"
import script from "./ApiGolfRateShow.vue?vue&type=script&lang=ts"
export * from "./ApiGolfRateShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports